export const getVatNoRegex = (countryId = 'DK') => {
  switch (countryId) {
    case 'NL':
      // BTW -> Expected format: "NL123456789B01"
      return /^NL\d{9}B\d{2}$/i
    case 'DE':
      // USt-IdNr -> Expected format: "DE123456789"
      return /^DE\d{9}$/
    case 'FR':
      // TVA -> Expected format: "FRxx123456789" where xx can be any two alphanumeric characters
      return /^FR[A-Z0-9]{2}\d{9}$/
    default:
      // For other countries, no specific format is enforced
      return /.*/
  }
}
